export default {
  OW: ['OWY'],
  RT: ['RTN']
}
